/**
 * Mobile Bottom Fade — mirror of MobileTopBar's frosted strip, flipped.
 *
 * The top of the list fades out under MobileTopBar (a downward gradient +
 * progressively-masked blur). Without a matching element the bottom of the
 * list ends on a hard edge and the floating FAB / "Finish setup" pill hover
 * over sharp text. This lays the same treatment at the bottom so content
 * dissolves into a chrome band the FAB and pill sit within.
 *
 * pointer-events-none throughout — it never intercepts taps on the list or the
 * controls above it. Only visible below `md`.
 */
export function MobileBottomFade() {
  return (
    <div
      aria-hidden="true"
      data-testid="mobile-bottom-fade"
      className="md:hidden pointer-events-none fixed inset-x-0 bottom-0 z-20 overflow-hidden"
      style={{
        // Tall enough to cover the FAB / pill band plus the home-indicator inset.
        height: 'calc(6rem + env(safe-area-inset-bottom, 0px))',
      }}
    >
      {/* Fallback tinted gradient — dark mode (bottom opaque → top transparent) */}
      <div
        className="pointer-events-none absolute inset-0 hidden dark:block"
        style={{
          background:
            'linear-gradient(to top, rgba(13,21,32,1) 0%, rgba(13,21,32,0.9) 38%, rgba(13,21,32,0.55) 68%, rgba(13,21,32,0) 100%)',
        }}
      />
      {/* Fallback tinted gradient — light mode (#FAFAFA = surface-base-light) */}
      <div
        className="pointer-events-none absolute inset-0 block dark:hidden"
        style={{
          background:
            'linear-gradient(to top, rgba(250,250,250,1) 0%, rgba(250,250,250,0.9) 38%, rgba(250,250,250,0.55) 68%, rgba(250,250,250,0) 100%)',
        }}
      />
      {/* Blur layer with progressive mask — strongest at the bottom, gone at the top */}
      <div
        data-testid="mobile-bottom-fade-blur"
        className="pointer-events-none absolute inset-0 backdrop-blur-md"
        style={{
          maskImage:
            'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 42%, rgba(0,0,0,0.72) 70%, rgba(0,0,0,0) 100%)',
          WebkitMaskImage:
            'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 42%, rgba(0,0,0,0.72) 70%, rgba(0,0,0,0) 100%)',
        }}
      />
    </div>
  );
}
